import { DefaultParams } from '@/api/bbsworld/default';
import { ClientAuth } from '@/classes/ClientAuth';
import { Device } from '@/classes/Device';
import { API_URL, API_VERSION } from '@/constants';
import { Video } from '@/types';
import { stringify } from 'qs';

export type GetVideoParams = {
  id: number;
  cursor: string;
  hls?: '1' | '0';
} & DefaultParams;

export async function getVideo({ id, ...params }: GetVideoParams): Promise<Video> {
  const response = await fetch(
    `${API_URL}/api/${API_VERSION}/videos/${id}?${stringify({ deviceId: Device.uuid, ...params })}`,
    {
      method: 'GET',
      headers: ClientAuth.headers,
      credentials: 'include',
    },
  );
  if (!response.ok) throw response;

  const data = await response.json();

  return data;
}

export type GetPreviewThumbnailSignedUrlParams = {
  id: number;
  language: string;
  index: number;
};

export async function getPreviewThumbnailSignedUrl({
  id,
  ...params
}: GetPreviewThumbnailSignedUrlParams): Promise<string> {
  const response = await fetch(
    `${API_URL}/api/${API_VERSION}/videos/${id}/thumbnails?${stringify({ deviceId: Device.uuid, ...params })}`,
    {
      method: 'GET',
      headers: ClientAuth.headers,
      credentials: 'include',
    },
  );
  const data = await response.text();

  return data;
}
